import { querySchema } from './district-list-filter.schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';

export function DistrictListFilter() {
  const { register } = useFilterForm(querySchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på distrikt..." aria-label="Sök" />
    </Table.Bar>
  );
}
